import React from "react";
import styles from "./RequestDemo.module.scss";
import { useNavigate } from "react-router-dom";

const DemoRequest = () => {
  const navigate = useNavigate();

  const handleNavigation = (route) => {
    navigate(route); // Navigate to the specified route
  };

  return (
    <section className={styles.demoRequest_sec}>
      <div className={styles.content}>
        <h2 className={styles.title}>Request Demo</h2>
        <p className={styles.subtitle}>Are you ready for a demo?</p>
        <p className={styles.description}>
          To inquire about how Sealkloud's services and products can provide
          personalized experiences for your company, please fill out this form.
          We will contact you shortly regarding your demo request.
        </p>
        <button
          className={styles.buttonPrimary}
          onClick={() => handleNavigation("/contact")}
        >
          Request a Demo
        </button>
      </div>
      <div className={styles.imageContainer}>
        <img
          src="/assests/demo_2.png"
          alt="Demo Illustration"
          className={styles.image}
        />
      </div>
    </section>
  );
};

export default DemoRequest;
